import { RRule } from "rrule";

export const repeatEndItemList = [
    {
      id: 'never',
      name: 'Never',
    },
    {
      id: 'until',
      name: 'Until',
    },
    {
      id: 'count',
      name: 'Count',
    },
  ];

  export const DAYS = [
    { id: RRule.SU, name: 'Sunday', label: 'S' },
    { id: RRule.MO, name: 'Monday', label: 'M' },
    { id: RRule.TU, name: 'Tuesday', label: 'T' },
    { id:  RRule.WE, name: 'Wednesday', label: 'W' },
    { id:  RRule.TH, name: 'Thursday', label: 'T' },
    { id:  RRule.FR, name: 'Friday', label: 'F' },
    { id:  RRule.SA, name: 'Saturday', label: 'S' },
  ];


  export const MONTHS = [
    {id:1, name:'January', enumValue:RRule},
    {id:2, name:'February'},
    {id:3, name:'March'},
    {id:4, name:'April'},
    {id:5, name:'May'},
    {id:6, name:'June'},
    {id:7, name:'July'},
    {id:8, name:'August'},
    {id:9, name:'September'},
    {id:10, name:'October'},
    {id:11, name:'November'},
    {id:12, name:'December'}

  ]
  export const OnWeekOfList = [
    { id: 1, name: 'First' , },
    { id: 2, name: 'Second' },
    { id: 3, name: 'Third' },
    { id: 4, name: 'Forth' },
    { id: 5, name: 'Last' },
  ];


  